import { render, staticRenderFns } from "./hubInscan.vue?vue&type=template&id=245e1565&"
import script from "./hubInscan.vue?vue&type=script&lang=js&"
export * from "./hubInscan.vue?vue&type=script&lang=js&"
import style0 from "./hubInscan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports